import Vue from 'vue'
import Work from './components/Work.vue'
import FilterExpertise from './components/FilterExpertise.vue'
import Clients from './components/Clients.vue'
import WordsOfWisdomSimple from './WordsOfWisdomSimple.vue'
import WordsOfWisdom from './WordsOfWisdom.vue'
import RelatedWork from './RelatedWork.vue'
import SelectedPages from './SelectedPages.vue'

Vue.config.productionTip = false

new Vue({
  render: h => h(Work),
}).$mount('#work-app')
  
new Vue({
  render: h => h(Clients),
}).$mount('#clients-app')
new Vue({
  render: h => h(FilterExpertise),
}).$mount('#filter-expertise-app')
new Vue({
  render: h => h(WordsOfWisdomSimple),
}).$mount('#words-of-wisdom-simple-app')

new Vue({
  render: h => h(WordsOfWisdom),
}).$mount('#words-of-wisdom-app')

new Vue({
  render: h => h(RelatedWork),
}).$mount('#related-work-app')

new Vue({
  render: h => h(SelectedPages),
}).$mount('#selected-pages-app')